module.exports = __webpack_public_path__ + "img/SALE.3c5ab8ca.svg";